<template>
  <svg :style="style" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_zhuce">
      <path id="Vector" d="M8.5 3H4.5C3.94771 3 3.5 3.44771 3.5 4V8" stroke="white" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
      <path id="Vector_2" d="M8.5 21H4.5C3.94771 21 3.5 20.5523 3.5 20V16" stroke="white" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
      <path id="Vector_3" d="M16.5 21H20.5C21.0523 21 21.5 20.5523 21.5 20V16" stroke="white" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
      <path id="Vector_4" d="M16.5 3H20.5C21.0523 3 21.5 3.44771 21.5 4V8" stroke="white" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
      <path id="Vector_5" d="M16.5 12H8.5" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      <path id="Vector_6" d="M12.5 16V8" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'registry',
  props: {
    width: {
      type: String,
      default: '25px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>